import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeNotification } from '../../../../store/commonSlice';

const ToastError = () => {
	const dispatch = useDispatch();
	const {
		common: { notificationError }
	} = useSelector((state: any) => state);

	let notificationType = 'error-alertbox';
	let notificationIcon = 'icon-error';

	if (notificationError.type === 'SUCCESS') {
		notificationType = 'success-alertbox';
		notificationIcon = 'icon-success';
	}

	const closeToastError = () => {
		if (notificationError.isVisible) {
			dispatch(closeNotification());
		}
	};

	return (
		<div role="alert" aria-live="assertive">
			<div
				className="toast-wrap"
				style={{ zIndex: 999999, display: notificationError.isVisible ? 'block' : 'none' }}>
				<div className={`toast-alertbox ${notificationType}`}>
					<em aria-hidden="true" className={`${notificationIcon} icon-circle`}></em>
					<div className="alertbox-info">
						<h3>{notificationError.heading}</h3>
						<span className="alert-cnt">{notificationError.body}</span>
					</div>
					<button
						className="modal-close-icon"
						aria-label="Close"
						onClick={closeToastError}></button>
				</div>
			</div>
		</div>
	);
};

export default ToastError;
